import { IReduxState } from "app/types/state";

export const getIsAnalyticsAllowed = (state: IReduxState) => state.analyticsReducer.cookieSettings.isAnalyticsCookieAllowed;
export const getUserCookieSettings = (state: IReduxState) => state.analyticsReducer.cookieSettings;
export const getIsUserSetCookieSettings = (state: IReduxState) => state.analyticsReducer.isUserSetCookieSettings;

